export const UpdateTicketState = (data,stage,stageName) =>{
 const ticketStatus = {
  id:data.id,
  ticketStatus: {
    description: stageName,
    id: stage,
    status: stageName
  }}
return ticketStatus;
};
